var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_vm._v("\n         Payment Infos\n     ")]),_c('v-card-text',[_vm._v("\n         "+_vm._s(_vm.order.cc_brand)+"\n         "+_vm._s(_vm.order.wo_po_number)+"\n     ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }